// AI Agents tab — instrumentation for the AI agents in our delivery pipeline.
// Code-review agent is live now; the QA agent slots in here once it's online.

import CodeReviewInsights from './CodeReviewInsights.jsx'
import { PULSE_COLORS } from './pulseConfig.js'

export default function AgentInsights({ refreshSignal }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <CodeReviewInsights refreshSignal={refreshSignal} />

            {/* QA agent — not live yet (as of 2026-06). Placeholder so the surface exists. */}
            <div
                style={{
                    background: PULSE_COLORS.cardBg,
                    borderRadius: '12px',
                    padding: '20px',
                    border: `1px dashed ${PULSE_COLORS.border}`,
                    opacity: 0.75,
                }}
            >
                <h3 style={{ color: PULSE_COLORS.text, fontWeight: 600, fontSize: '16px', margin: 0 }}>
                    🧪 QA Agent — coming soon
                </h3>
                <p style={{ color: PULSE_COLORS.textMuted, fontSize: '13px', margin: '6px 0 0' }}>
                    Once the QA agent is live, this section will track defect containment (caught in QA vs escaped to
                    prod), QA cycle time, and its contribution to time-to-release.
                </p>
            </div>
        </div>
    )
}
